export enum PRESET_THEME {
  Aura = 'aura',
  Lara = 'lara',
  Material = 'material',
  Nora = 'nora',
}
